import { render, staticRenderFns } from "./setDepartment.vue?vue&type=template&id=1009f924&"
import script from "./setDepartment.vue?vue&type=script&lang=ts&"
export * from "./setDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports